import {Injectable} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {StateStorageService} from '../admin/services/state-storage.service';

@Injectable({
    providedIn: 'root',
})
export class UnauthorizedHttpInterceptor implements HttpInterceptor {
    constructor(private router: Router,
                private stateStorageService: StateStorageService) {
    }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMsg = '';
                if ((error.status === 401 && error.error.error === 'unauthorized') ||
                    error.status === 403) {
                    errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
                    console.log(errorMsg);
                    console.log('before open login unautho...');
                    if (error.status === 403) {
                        this.stateStorageService.storeCurrentUrl();
                    }
                    //this.router.navigate(['/']);
                    return throwError(() => errorMsg);
                }

                return throwError(() => error);
            })
        );
    }
}
